export default [
  {id: 1, codigo: 'GALPAO', label: 'Galpão', showTipo: true},
  {id: 2, codigo: 'CASA_FARINHA', label: 'Casa de Farinha', showTipo: true},
  {id: 3, codigo: 'RESIDENCIA', label: 'Residência', showTipo: false},
  {id: 4, codigo: 'CASA_VAQUEIRO', label: 'Casa do Vaqueiro', showTipo: true},
  {id: 5, codigo: 'CASA_SAL', label: 'Casa de Sal', showTipo: true},
  {id: 6, codigo: 'DEPOSITO', label: 'Depósito', showTipo: true},
  {id: 7, codigo: 'CURRAL_COMPLETO', label: 'Curral Completo', showTipo: true},
  {id: 8, codigo: 'CURRAL_CERCADO', label: 'Curral Cercado', showTipo: true},
  {id: 9, codigo: 'CURRAL_COBERTURA', label: 'Curral com Cobertura', showTipo: true},
  {id: 10, codigo: 'RESIDENCIA_CASEIRO', label: 'Residência do Caseiro', showTipo: false},
  {id: 11, codigo: 'CERCAS', label: 'Cercas', showTipo: true},
  {id: 12, codigo: 'ESTRADAS_INTERNAS', label: 'Estradas Internas', showTipo: true},
  {id: 13, codigo: 'TANQUE_PEIXES', label: 'Tanque de Peixes', showTipo: false},
  {id: 14, codigo: 'ACUDES', label: 'Açudes', showTipo: true},
  {id: 15, codigo: 'REPRESAS', label: 'Represas', showTipo: false},
  {id: 16, codigo: 'POCO_AMAZONAS', label: 'Poço Amazonas (calculado em metro de profundidade)', showTipo: false},
  {id: 17, codigo: 'POCO_ARTESIANO', label: 'Poço Artesiano (calculado em metro de profundidade)', showTipo: false},
  {id: 18, codigo: 'OUTROS', label: 'Outros', showTipo: true}
]



// WEBPACK FOOTER //
// ./src/utils/tipoEdificacoes.js